import { useState } from 'react';
import s from '../../styles/components/redeem/RedeemSuccess.module.css';

export default function RedeemSuccess({ ui, data }) {
  const { customer, reward } = data;
  const [timestamp] = useState(() => new Date().toLocaleTimeString());

  return (
    <div className={s.wrap}>
      <span className={s.eyebrow}>{ui.eyebrow}</span>
      <h2 className={s.headline}>{ui.headline}</h2>
      <div className={s.divider} />
      <div className={s.meta}>
        <div className={s.metaRow}>
          <span className={s.metaLabel}>Guest</span>
          <span className={s.metaValue}>{customer.name}</span>
        </div>
        <div className={s.metaRow}>
          <span className={s.metaLabel}>Reward</span>
          <span className={s.metaValue}>{reward.label}</span>
        </div>
        <div className={s.metaRow}>
          <span className={s.metaLabel}>{ui.timestampLabel}</span>
          <span className={s.metaValue}>{timestamp}</span>
        </div>
      </div>
      <div className={s.divider} />
      <p className={s.instruction}>{ui.instruction}</p>
    </div>
  );
}